const URL_TEST = /https?:\/\/[^\s]+|www\.[^\s]+\.[^\s]{2,}/i;
const URL_SPLIT = /(https?:\/\/[^\s]+|www\.[^\s]+\.[^\s]{2,})/gi;
const URL_FULL = /^(https?:\/\/[^\s]+|www\.[^\s]+\.[^\s]{2,})$/i;

document.addEventListener('paste', (event) => {
  const editor = event.target.closest('trix-editor')?.editor;
  if (!editor) return;

  const pastedText = event.clipboardData?.getData('Text')?.trim();
  if (!pastedText || !URL_TEST.test(pastedText)) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  editor.recordUndoEntry('Auto Link Paste');

  pastedText.split(/\r?\n/).forEach((line, lineIndex) => {
    if (lineIndex > 0) editor.insertLineBreak();

    line.split(URL_SPLIT).forEach((part) => {
      if (!part) return;
      if (URL_FULL.test(part)) {
        const [start] = editor.getSelectedRange();
        editor.insertString(part);
        editor.setSelectedRange([start, start + part.length]);
        editor.activateAttribute('href', part);
        editor.setSelectedRange([start + part.length, start + part.length]);
        editor.deactivateAttribute('href');
      } else {
        editor.insertString(part);
      }
    });
  });
}, true);
